import React from 'react';
import { IconButton, Badge, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useHelp } from '../../context/System/HelpContext';

const SizeSoftXHelpFloatButton = ({ variant = "float" }) => {
    const { toggleHelpPanel, isOpen, isSpeaking } = useHelp();
    const isMenu = variant === "menu";

    return (
        <Tooltip title={isOpen ? "Cerrar ayuda" : "Ayuda"} placement={isMenu ? "bottom" : "right"}>
            <IconButton
                onClick={toggleHelpPanel}
                className={`${isMenu ? 'help-menu-button' : 'help-float-button'} ${isOpen ? 'active' : ''} ${isSpeaking ? 'speaking' : ''}`}
                color={isMenu ? "inherit" : undefined}
                sx={isMenu ? {
                    color: '#fff',
                    backgroundColor: isOpen ? 'rgba(255,255,255,0.18)' : 'transparent',
                    '&:hover': {
                        backgroundColor: 'rgba(255,255,255,0.24)',
                    },
                    '&.speaking': {
                        color: '#ffeb3b',
                        animation: 'pulse 1.5s infinite',
                    },
                    '@keyframes pulse': {
                        '0%': { boxShadow: '0 0 0 0 rgba(255, 235, 59, 0.35)' },
                        '70%': { boxShadow: '0 0 0 10px rgba(255, 235, 59, 0)' },
                        '100%': { boxShadow: '0 0 0 0 rgba(255, 235, 59, 0)' },
                    },
                } : {
                    position: 'fixed',
                    bottom: { xs: 20, sm: 24 },
                    left: { xs: 20, sm: 24 },
                    zIndex: 9999,
                    width: { xs: 52, sm: 56 },
                    height: { xs: 52, sm: 56 },
                    backgroundColor: isOpen ? '#1976d2' : '#0d47a1',
                    color: '#fff',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    '&:hover': {
                        backgroundColor: '#1565c0',
                        transform: 'scale(1.08)',
                        boxShadow: '0 6px 24px rgba(0,0,0,0.35)',
                    },
                    '&:active': {
                        transform: 'scale(0.95)',
                    },
                    '&.speaking': {
                        backgroundColor: '#d32f2f',
                        animation: 'pulse 1.5s infinite',
                    },
                    '@keyframes pulse': {
                        '0%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0.4)' },
                        '70%': { boxShadow: '0 0 0 12px rgba(211, 47, 47, 0)' },
                        '100%': { boxShadow: '0 0 0 0 rgba(211, 47, 47, 0)' },
                    },
                }}
            >
                <Badge
                    color="error"
                    variant="dot"
                    invisible={!isSpeaking}
                    sx={{ '& .MuiBadge-badge': { backgroundColor: '#ff1744' } }}
                >
                    <HelpOutlineIcon sx={{ fontSize: isMenu ? 24 : { xs: 24, sm: 28 } }} />
                </Badge>
            </IconButton>
        </Tooltip>
    );
};

export default SizeSoftXHelpFloatButton;
